import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IVisitFilter, IVisitState } from "../interfaces/IPatient";
import { fetchVisits, fetchVisitTypes } from "../apis/patientService";
import { uploadDocs } from "../apis/caseService";


const initialState: IVisitState = {
  allVisitTypes: null,
  totalAvailableVisits: null,
  isFetchingAllVisits: false,
  error: null,
  isLoading: false,
  uploadDocument: {
    editMode: false,
    editedFields: {},
    selectedFile: null,
  },
  visitFilters: {
    endDate: null,
    orderBy: "DESC",
    pageNumber: 1,
    pageSize: 10,
    searchTerm: null,
    startDate: null,
  },
};

export const getVisitData = createAsyncThunk(
  "visits/getVisitData",
  async ({
    filters
  }: {
    filters: IVisitFilter;
  }) => {
    if (filters) {
      const response = await fetchVisits(filters);
      return response;
    }
  }
);

export const getVisitTypes = createAsyncThunk(
  "visits/getVisitTypes",
  async () => {
      const response = await fetchVisitTypes();
      return response;
    }
);

export const UploadDocument = createAsyncThunk(
  "visits/UploadDocument",
  async ({ formData, accessToken }: { formData: any; accessToken: string }) => {
    const response = await uploadDocs(formData, accessToken);
    return response;
  }
);

const visitSlice = createSlice({
  name: "visits",
  initialState,
  reducers: {
    setVisitFilters: (state, action: PayloadAction<IVisitFilter>) => {
      state.visitFilters = action.payload;
    },

    clearPageToVisitIdMap: (state) => {
      state.totalAvailableVisits = null;
    },
    setDates: (state, action: PayloadAction<any>) => {
      state.visitFilters.startDate = action.payload.startDate;
      state.visitFilters.endDate = action.payload.endDate;
    },
    setSelectedFile: (
      state,
      action: PayloadAction<{file: File; documentType: string; stage: string } | null>
    ) => {
      if(state.uploadDocument) state.uploadDocument.selectedFile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVisitData.pending, (state) => {
        state.isFetchingAllVisits = true;
        state.error = null;
      })
      .addCase(
        getVisitData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isFetchingAllVisits = false;
          state.totalAvailableVisits = action.payload;
          state.error = null;
        }
      )
      .addCase(getVisitData.rejected, (state, action) => {
        state.isFetchingAllVisits = false;
        state.error = action.error.message || "Failed to fetch visit data";
      })
      .addCase(UploadDocument.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        UploadDocument.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
        }
      )
      .addCase(UploadDocument.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getVisitTypes.pending, (state, action) => {
        state.allVisitTypes = null
      })
      .addCase(getVisitTypes.fulfilled, (state, action) => {
        state.allVisitTypes = action.payload
      })
      .addCase(getVisitTypes.rejected, (state, action) => {
        state.allVisitTypes = null
      });
  },
});

export const { setVisitFilters, clearPageToVisitIdMap ,setDates, setSelectedFile} =
  visitSlice.actions;
export default visitSlice.reducer;
